type DashboardWidgetSettingsProps = {
    showCalendar: boolean;
    showTodo: boolean;
    showCOImpact: boolean;
    showRepartition: boolean;
    showTipofTheDay: boolean;
    showDailyMood: boolean;
    showNotepad: boolean;
    showMeteo: boolean;
};
export default class DashboardWidgetSettings {
    showCalendar: boolean;

    showTodo: boolean;

    showRepartition: boolean;

    showTipofTheDay: boolean;

    showCOImpact?: boolean; // unused for now

    showDailyMood?: boolean; // unused for now

    showNotepad?: boolean; // unused for now

    showMeteo?: boolean; // unused for now

    constructor({
        showCalendar,
        showTodo,
        showCOImpact,
        showRepartition,
        showTipofTheDay,
        showDailyMood,
        showNotepad,
        showMeteo,
    }: DashboardWidgetSettingsProps) {
        this.showCalendar = showCalendar;
        this.showTodo = showTodo;
        this.showCOImpact = showCOImpact;
        this.showRepartition = showRepartition;
        this.showTipofTheDay = showTipofTheDay;
        this.showDailyMood = showDailyMood;
        this.showNotepad = showNotepad;
        this.showMeteo = showMeteo;
    }
}
